import { render } from "./fancybox.vue?vue&type=template&id=22569c87"
import script from "./fancybox.vue?vue&type=script&lang=js"
export * from "./fancybox.vue?vue&type=script&lang=js"

import "./fancybox.vue?vue&type=style&index=0&id=22569c87&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__